// extracted by mini-css-extract-plugin
export default {"chip_container":"Chip_chip_container__4rdIy","chip_text":"Chip_chip_text__yFeuT","circle_chip":"Chip_circle_chip__H8Uxv"};